/**
 * user上监听事件集合
 * */

type EventName =
  | 'login-type-changed'
  | 'verified'
  | 'show-org-list'
  | 'org-deregistered'
  | 'org-freezed'
  | 'org-ip-restricted'
  | 'switch-org-finished'
  | 'org-selected'
  | 'logined'
  | 'login-failed'
  | 'switch-org-started'
  | 'after-login'
  | 'after-logout'
  | 'switch-org-failed'
  | 'reset-password';
const getList = Symbol('getUserEvents');
type Callback = (params?: any) => void;
interface Listener extends Callback {
  once?: boolean;
}
type Listeners = Record<EventName, Array<Listener>>;
class UserEventBus {
  listeners: Listeners;
  constructor() {
    this.listeners = {
      'login-type-changed': [],
      verified: [],
      'show-org-list': [],
      'org-deregistered': [],
      'org-freezed': [],
      'org-ip-restricted': [],
      'org-selected': [],
      logined: [],
      'login-failed': [],
      'switch-org-started': [],
      'switch-org-finished': [],
      'after-login': [],
      'after-logout': [],
      'switch-org-failed': [],
      'reset-password': [],
    };
  }
  [getList](action: EventName): Array<Listener> {
    if (!this.listeners[action]) {
      this.listeners[action] = [];
    }
    return this.listeners[action];
  }
  public on(action: 'login-type-changed', callback: (loginType: string) => void): UserEventBus;
  public on(action: 'verified', callback: () => void): UserEventBus;
  public on(action: 'show-org-list', callback: () => void): UserEventBus;
  public on(
    action: 'org-deregistered',
    callback: ({ orgId, editionFlag, cb }: { orgId: number; editionFlag: string; cb: Function }) => void,
  ): UserEventBus;
  public on(action: 'org-freezed', callback: ({ editionFlag }: { editionFlag: string }) => void): UserEventBus;
  public on(action: 'org-ip-restricted', callback: ({ isInvitation }: { isInvitation: boolean }) => void): UserEventBus;
  public on(action: 'org-selected', callback: () => void): UserEventBus;
  public on(action: 'logined', callback: () => void): UserEventBus;
  public on(action: 'login-failed', callback: (error: any) => void): UserEventBus;
  public on(action: 'switch-org-started', callback: () => void): UserEventBus;
  public on(action: 'switch-org-finished', callback: () => void): UserEventBus;
  public on(action: 'after-login', callback: () => void): UserEventBus;
  public on(action: 'after-logout', callback: () => void): UserEventBus;
  public on(action: 'switch-org-failed', callback: () => void): UserEventBus;
  public on(action: EventName, callback: Listener): UserEventBus;
  public on(action: EventName, callback: Listener): UserEventBus {
    this[getList](action).push(callback);
    return this;
  }
  once(action: EventName, callback: Listener): UserEventBus {
    if (!callback) return this;
    const listener = callback;
    listener.once = true;
    this.on(action, listener);
    return this;
  }
  off(action: EventName, callback: Listener | '*'): UserEventBus {
    const list = this[getList](action);
    if (callback === '*') {
      for (let i = list.length - 1; i >= 0; i -= 1) {
        list.splice(i, 1);
      }
    } else {
      for (let i = list.length - 1; i >= 0; i -= 1) {
        if (callback === list[i]) {
          list.splice(i, 1);
        }
      }
    }
    return this;
  }
  emit(action: EventName, data?: string | object): UserEventBus {
    const list = this[getList](action).map(cb => cb);
    for (let i = 0; i < list.length; i += 1) {
      const callback = list[i];
      callback(data);
      if (list[i].once) {
        this.off(action, list[i]);
      }
    }
    return this;
  }
}
export default UserEventBus;
